import { toast } from 'react-toastify';
import Notification from '../components/Notification';

export const Notify = (
  title: string,
  body: string,
  closeAfter: number | false = 6000,
) => {
  toast(<Notification title={title} body={body} />, {
    position: 'top-center',
    autoClose: closeAfter,
    className: 'toast__base',
    progressClassName: 'toast__progress',
  });
};

export const NotifyComponent = (
  component: React.ReactNode,
  closeAfter: number | false = 8000,
) => {
  toast(component, {
    position: 'top-center',
    autoClose: closeAfter,
    className: 'toast__base',
    progressClassName: 'toast__progress',
  });
};
